
import { defineComponent, SetupContext, ref, computed, onMounted, nextTick } from "vue";
import NativeClient from "@/client/native-client";
import PantryRadioItem from "./PantryRadioItem.vue";
import { DateValueInfo, PANTRY_STRING, PLATE_SELECT_DATE_TYPE, PLATE_DATE_SETTING, DETAIL_ITEM_TYPE, DETAIL_ITEM_TITLE } from "@/types/pantry";
import DateUtil from "@/utils/date-util";

export default defineComponent({
  name: "PantryDateValueDialog",
  components: {
    PantryRadioItem
  },
  props: {
    info: {
      type: DateValueInfo,
      default: null,
      require: true
    },
  },
  setup(props, context: SetupContext) {
    const selectId = ref(0);
    const date = ref("");
    const dateComputed = computed({
      get: () => date.value,
      set: value => {
        NativeClient.sendDebugLog("PantryDateValueDialog dateComputed set value=" + JSON.stringify(value));
        if (value == "") {
          date.value = "";
          selectId.value = PLATE_SELECT_DATE_TYPE.NONE;
        } else {
          date.value = value;
          selectId.value = PLATE_SELECT_DATE_TYPE.DATE;
        }
        NativeClient.sendDebugLog("PantryDateValueDialog dateComputed set date.value=" + JSON.stringify(date.value));
      }
    });
    const onClickSetting = () => {
      NativeClient.sendDebugLog("PantryDateValueDialog onClickSetting selectId.value=" + selectId.value + " date.value=" + date.value);
      const itemType = (props.info != null) ? props.info.itemType : -1;
      const dateValue = (selectId.value == PLATE_SELECT_DATE_TYPE.NONE) ? "" : date.value;
      context.emit("click-setting", itemType, selectId.value, dateValue, (props.info != null) ? props.info.date : null);
      selectId.value = PLATE_SELECT_DATE_TYPE.NONE;
    };
    const onClickClose = () => {
      context.emit("click-close");
    };
    const getRadioIcon = (check: boolean) => {
      return (check) ? require("@/assets/images/radio_on.png") : require("@/assets/images/radio_off.png");
    };
    const getRadioImage = (id: number) => {
      return getRadioIcon(selectId.value == id);
    };
    const selectChecked = (id: number) => {
      selectId.value = id;
      switch (id) {
        case PLATE_SELECT_DATE_TYPE.DATE:
          if (date.value == "") {
            date.value = DateUtil.getToday();
          }
          break;
        case PLATE_SELECT_DATE_TYPE.NONE:
          date.value = "";
          break;
      }
    };

    const updateDate = computed(() => {
      NativeClient.sendDebugLog("PantryDateValueDialog updateDate info=" + JSON.stringify(props.info));
      let result = null;
      if (props.info != null) {
        result = props.info.date;
      }
      if (result == null) {
        result = "";
        selectId.value = PLATE_SELECT_DATE_TYPE.NONE;
      } else {
        selectId.value = PLATE_SELECT_DATE_TYPE.DATE;
      }
      date.value = result;
    });

    const getNoneValue = () => {
      let result = PANTRY_STRING.PANTRY_NONE_SETTING;
      if (props.info != null && props.info.valueType == PLATE_DATE_SETTING.NOTIFICATION) {
        result = PANTRY_STRING.PANTRY_NONE_NOTIFICATION;
      }
      return result;
    };
    const getTitle = () => {
      let result = "";
      if (props.info != null) {
        switch(props.info.itemType) {
          case DETAIL_ITEM_TYPE.PURCHASE_DATE:
            result = DETAIL_ITEM_TITLE.PURCHASE_DATE;
            break;
          case DETAIL_ITEM_TYPE.EXPIRATION_DATE:
            result = DETAIL_ITEM_TITLE.EXPIRATION_DATE;
            break;
          case DETAIL_ITEM_TYPE.NOTIFICATION:
            result = DETAIL_ITEM_TITLE.NOTIFICATION;
            break;
        }
      }
      return result;
    };
    const isShowInput = () => {
      return date.value != "";
    };
    const clickEmpty = () => {
      date.value = DateUtil.getToday();
    };
    return {
      selectId,
      getRadioImage,
      onClickSetting,
      onClickClose,
      dateComputed,
      selectChecked,
      updateDate,
      getNoneValue,
      getTitle,
      isShowInput,
      clickEmpty
    }
  }
});
